import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isMobile } from '../../utils/ScreenSizeHelper';
import { MobileNotAvailableIcon } from '../../utils/assets/iconComponent/MobileNotAvailable';
import AtomicButton from '../../atomic/button/Button';

const MobileAppNotReady = () => {
  const navigate = useNavigate();
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
          marginTop: '25%',
        }}
      >
        <MobileNotAvailableIcon />
        <div
          style={{
            textAlign: 'center',
            color: 'red',
            fontFamily: 'Inter Regular',
            fontSize: '18px',
            marginTop: '15px',
            width: '80%',
          }}
        >
          We apologize for the inconvenience. Login and sign-up are not yet available on mobile
          devices. Please switch to an iPad, tablet, laptop, or desktop computer to access these
          pages.
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid black',
            margin: '30px',
            width: '80%',
            height: '200px',
            borderRadius: '5px',
            backgroundColor: 'rgb(250, 243, 225)',
            textAlign: 'center',
          }}
        >
          Would you like to connect with your local Sales or Account Setup team?
          <AtomicButton
            label={'Talk to Our Local Team'}
            handleSubmit={() => {
              navigate('/merchant-contact');
              window.location.reload();
            }}
            style={{
              backgroundColor: '#181436',
              minWidth: '140px',
              maxWidth: '200px',
              height: '40px',
              fontSize: isMobile ? '14px' : '16px',
            }}
            loading={false}
            disabled={false}
          />
        </div>
      </div>
    </>
  );
};

export default MobileAppNotReady;
